import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to detect network status (online/offline)
 * Returns { isOnline, isOffline } and provides real-time updates
 */
export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  const handleOnline = useCallback(() => {
    setIsOnline(true);
  }, []);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
  }, []);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return {
    isOnline,
    isOffline: !isOnline
  };
};

export default useNetworkStatus;
